import { render } from "./AppNotFound.vue?vue&type=template&id=0b88c011"
import script from "./AppNotFound.vue?vue&type=script&lang=js"
export * from "./AppNotFound.vue?vue&type=script&lang=js"

import "./AppNotFound.vue?vue&type=style&index=0&id=0b88c011&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__